<div class="panel">
  <h3>Veículo</h3>
  <p class="border">{{veiculo.descricao}}</p>
  <a (click)="onClickAlterar()" class="change-car" *ngIf="veiculo.descricao">alterar</a>
</div>